import {
    ADMIN_COMPANIES_ERROR,
    ADMIN_COMPANIES_SUCESS,
    ADMIN_COMPANIES_REQUEST,
    ADMIN_COMPANIES_CHANGE_COUNT,
    ADMIN_COMPANIES_CHANGE,
    ADMIN_COMPANIES_FILTERS_RESET
} from '../actions/adminCompaniesActions';
import {CookiesSettings} from '../helpers/cookiesHelper'

let cookiesSetting = new CookiesSettings("adminCompanies")

let size = cookiesSetting.get("size");
if(!size){
    size = 15
    cookiesSetting.set("size",size)
}

const initialState={
    data:[],
    fetching:false,
    set:false,
    page:1,
    size:size,
    total:0,
    needRefresh: false,
    name:"",
    filters:{
        status:"null",

        shard:""
    }
}



export default function adminCompanies(state = initialState, action){
    switch (action.type){
        case ADMIN_COMPANIES_REQUEST:
            return{
                ...state,
                fetching:true
            }
        case ADMIN_COMPANIES_ERROR:
            return{
                ...state,
                fetching:false,
                needRefresh:false,
                data:initialState.data
            }
        case ADMIN_COMPANIES_SUCESS:
            return{
                ...state,
                fetching:false,
                set:true,
                data:action.payload.companies,
                total:action.payload.total,
                needRefresh:false
            }
        case ADMIN_COMPANIES_CHANGE_COUNT:
            cookiesSetting.set("size",action.payload)
            return{
                ...state,
                needRefresh:true,
                size:action.payload,
                page:initialState.page
            }
        case ADMIN_COMPANIES_CHANGE:
            return{
                ...state,
                [action.payload.field]:action.payload.value
            }
        case ADMIN_COMPANIES_FILTERS_RESET:
            return{
                ...state,
                needRefresh:true,
                page:1,
                filters:initialState.filters,
                name:initialState.name
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/adminCompanies.js